import Axios from 'axios';
import { OrderCircle_CONFIG } from '@/js/config.js';
const RESOURCE_NAME = OrderCircle_CONFIG.API_URL + 'address';

export default {
    getStates(token) {
        return Axios.get(RESOURCE_NAME + '/states');
    },
    getShippingAddress(customerId) {
        var shippingAddressUrl = OrderCircle_CONFIG.API_URL + 'customers/' + customerId + '/shipping-addresses';
        return Axios.get(`${shippingAddressUrl}`);
    },
    createShippingAddress(data, customerId) {
        var shippingAddressUrl = OrderCircle_CONFIG.API_URL + 'customers/' + customerId + '/shipping-addresses';
        return Axios.post(`${shippingAddressUrl}`, data);
    },
    updateShippingAddress(data, customerId, addressId) {
        var shippingAddressUrl = OrderCircle_CONFIG.API_URL + 'customers/' + customerId + '/shipping-addresses/' + addressId;
        return Axios.put(`${shippingAddressUrl}`, data);
    },
    createBillingAddress(data, customerId) {
        var billingAddressUrl = OrderCircle_CONFIG.API_URL + 'customers/' + customerId + '/billing-addresses';
        return Axios.post(`${billingAddressUrl}`, data);
    },
    updateBillingAddress(data, addressId ,customerId) {
        var billingAddressUrl = OrderCircle_CONFIG.API_URL + 'customers/' + customerId + '/billing-addresses/' + addressId;
        return Axios.put(`${billingAddressUrl}`, data);
    },
    getBillingAddress(customerId, addressId){
        let billingAddressUrl = OrderCircle_CONFIG.API_URL + 'customers/' + customerId + '/billing-address/' + addressId;
        return Axios.get(billingAddressUrl);
    },
    getBillingAddresses(customerId) {
        let billingAddressUrl = OrderCircle_CONFIG.API_URL + 'customers/' + customerId + '/billing-addresses';
        return Axios.get(`${billingAddressUrl}`);
    },
};
